import { StoryblokGridCard } from './StoryblokGridCard'

import { createGridCard } from './__mocks__/gridCard'

export { createGridCard }

// Re-export for backward compatibility
export const dummyGridCardBlok = createGridCard()

export default StoryblokGridCard
